import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const useFetch = <DataType>(url: string) => {
  const [data, setData] = useState<DataType | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const fetchData = useCallback(async () => {
    if (!url) {
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(url);
      if (response?.status === 200) {
        setData(response?.data);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      //TODO consider retuning an error here
    }
  }, [url]);

  useEffect(() => {
    setIsLoading(true);
    fetchData();
    return () => {
      setIsLoading(false);
    };
  }, [fetchData]);

  return { data, loading, isLoading };
};
